import * as React from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import IndexPageComponent from "@src/components/IndexPage";

const IndexPage = (props) => {
	const { data } = props;
	const findImg = (imgName) => {
		//console.log(imgName);
		return data.allFile.edges.find((val) => val.node.relativePath === imgName);
	};
	const { pageInfo } = data;
	pageInfo.contents.hero.images = pageInfo.contents.hero.images.map((image) => {
		return (
			<GatsbyImage
				image={getImage(findImg(image.src).node)}
				alt="test"
				objectFit="cover"
				objectPosition={image.position}
				style={{ display: "block", height: "100%" }}
			/>
		);
	});
	pageInfo.contents.intro.info = pageInfo.contents.intro.info.map(
		(val, index) => ({
			...val,
			img: (
				<GatsbyImage
					image={getImage(findImg(val.img).node)}
					alt="test"
					objectFit="cover"
					style={{ display: "block", height: "100%" }}
				/>
			),
		})
	);
	pageInfo.contents.voice.voices = pageInfo.contents.voice.voices.map(
		(val, index) => {
			return {
				...val,
				voiceInfo: Object.assign(val.voiceInfo, {
					listImg: (
						<GatsbyImage
							image={getImage(findImg(val.voiceInfo.listImg.src).node)}
							alt="test"
							objectFit="cover"
							objectPosition={val.voiceInfo.listImg.position}
							style={{ display: "block", height: "100%" }}
						/>
					),
					img: (
						<GatsbyImage
							image={getImage(findImg(val.voiceInfo.img.src).node)}
							alt="test"
							objectFit="cover"
							objectPosition={val.voiceInfo.img.position}
							style={{ display: "block", height: "100%" }}
						/>
					),
				}),
				article: val.article.map((val) => {
					if (val.img) {
						return {
							...val,
							img: (
								<GatsbyImage
									image={getImage(findImg(val.img.src).node)}
									alt="test"
									objectFit="cover"
									style={{ display: "block", height: "100%" }}
									objectPosition={val.img.position}
								/>
							),
						};
					} else {
						return val;
					}
				}),
			};
		}
	);
	pageInfo.contents.gallery.introImg = (
		<GatsbyImage
			image={getImage(
				getImage(findImg(pageInfo.contents.gallery.introImg.src).node)
			)}
			alt="test"
			objectFit="cover"
			objectPosition={pageInfo.contents.gallery.introImg.position}
			style={{ display: "block", height: "100%" }}
		/>
	);
	pageInfo.contents.gallery.images = pageInfo.contents.gallery.images.map(
		(val) => ({
			...val,
			img: (
				<GatsbyImage
					image={getImage(getImage(findImg(val.src).node))}
					alt="test"
					objectFit="cover"
					objectPosition={val.position}
					style={{ display: "block", height: "100%" }}
				/>
			),
		})
	);
	return <IndexPageComponent {...pageInfo} />;
};

export const query = graphql`
	query indexPage {
		allFile: allFile {
			edges {
				node {
					relativePath
					childImageSharp {
						gatsbyImageData(
							layout: FULL_WIDTH
							quality: 100
							placeholder: BLURRED
						)
					}
				}
			}
		}
		pageInfo: dataYaml {
			showGrid
			contents {
				hero {
					images {
						src
						position
					}
				}
				intro {
					info {
						heading
						caption
						img
					}
					sectionTitles {
						subtitle
						title
					}
				}
				contact {
					lead
					note
					tel
				}
				gallery {
					lead
					sectionTitles {
						subtitle
						title
					}
					introImg {
						src
						position
					}
					images {
						caption
						src
						position
					}
				}
				header {
					navInfo {
						href
						label
					}
				}
				voice {
					lead
					sectionTitles {
						subtitle
						title
					}
					voices {
						voiceInfo {
							lead
							staffInfo {
								name
								position
								ruby
							}
							voiceNumber
							nextVoice
							voiceType
							listImg {
								src
								position
							}
							img {
								src
								position
							}
						}
						article {
							content {
								content {
									text
									type
								}
								img {
									src
									position
								}
								reverse
								text
								type
							}
							img {
								src
								position
							}
							reverse
							type
						}
					}
				}
				jobInfo {
					sectionTitles {
						subtitle
						title
					}
					info {
						data {
							detail
							title
						}
						title
					}
				}
			}
		}
	}
`;
export default IndexPage;
